import Heading from '../../components/atoms/Heading'
import Layout from '../../templates/Layout'
import { useUser } from '../../providers/User'
import { Role } from '../../types/enums'
import PendingInvoicesTable from '../../templates/InvoicesTable'

const ReceivableInvoicesPage = () => {
  const { user } = useUser()
  return (
    <Layout>
      {[Role.Director, Role.Finance, Role.Admin].includes(user!.role as Role) && (
        <>
          <Heading type="1" border margin>
            Facturas Enviadas
          </Heading>
          <PendingInvoicesTable status="sent" />
        </>
      )}
    </Layout>
  )
}

export default ReceivableInvoicesPage
